import { Flex, Text, VStack, Divider, Button } from '@chakra-ui/react';
import { AuthenticatedKeycloak } from '../../auth/keycloak';
import { FormattedMessage, useIntl } from 'react-intl';
import { ProductDef, cancelPaymentIntent } from '../../service/inventory';
import { StripePaymentIntent } from '../../service/stripe';

const productKey = 'streamsix_product_id';

export interface PendingPaymentItemProps {
    datas?: StripePaymentIntent[];
    index: number;
    date: string;
    products: ProductDef[];
    keycloak: AuthenticatedKeycloak;
}

export const PendingPaymentItem: React.FC<PendingPaymentItemProps> = ({
    datas,
    index,
    date,
    products,
    keycloak,
}) => {
    const intl = useIntl();

    const renderComponent = (data: StripePaymentIntent) => {
        const p = products.find((x) => data.metadata && data.metadata[productKey] === x.product_id);
        let status = '';
        let canCancel = false;
        switch (data.status) {
            case 'requires_payment_method':
                status = 'No payment method';
                canCancel = true;
                break;
            case 'requires_confirmation':
                status = 'Requires confirmation';
                canCancel = true;
                break;
            case 'requires_action':
                status = 'Requires action';
                canCancel = true;
                break;
            case 'processing':
                status = 'Processing';
                break;
            case 'requires_capture':
                status = 'On Hold';
                canCancel = true;
                break;
            case 'canceled':
                status = 'Canceled';
                break;
            case 'succeeded':
                status = 'Succeeded';
                break;
        }
        return (
            <>
                <Flex className={'compact-flex-container1'}>
                    <Text className="purchase-header">{status}</Text>
                </Flex>
                <Flex className={'compact-flex-container2'}>
                    <Flex className={'purchase-text'}>
                        <Text>{p?.product_name || ''}</Text>
                    </Flex>
                </Flex>
                <Flex className={'compact-flex-container3'}>
                    {canCancel && (
                        <Button
                            onClick={() => {
                                cancelPaymentIntent(data.id, keycloak.token);
                            }}
                        >
                            Cancel
                        </Button>
                    )}
                </Flex>
            </>
        );
    };

    return (
        <>
            <VStack className="transaction-compact-vstack">
                <Divider className="divider" />
                <Flex className={`transaction-compact`}>
                    <Flex className={'compact-flex-date-container'}>
                        <Text className="header-date-text">{date}</Text>
                    </Flex>
                </Flex>
                {datas &&
                    datas.map((data, idx) => (
                        <Flex
                            key={idx}
                            className={`transaction-compact${idx % 2 == 0 ? '' : '-light'}`}
                        >
                            {renderComponent(data)}
                        </Flex>
                    ))}
            </VStack>
        </>
    );
};
